// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.pdf-viewer {
  flex: 1;
  display: flex;
  flex-direction: column;
  overflow: hidden;
  background: #525659;
}

.pdf-canvas-container {
  position: relative;
  flex: 1;
  overflow: auto;
  display: flex;
  justify-content: center;
  align-items: flex-start;
  padding: 20px;
}

.pdf-canvas-container.has-hover {
  cursor: text;
}

.pdf-canvas-container.editing {
  cursor: default;
}

.text-overlay {
  position: absolute;
  top: 0;
  left: 0;
  pointer-events: none;
}

.pdf-canvas-wrapper {
  position: relative;
  display: block;
}

.text-block-highlight {
  position: absolute;
  border: 2px solid transparent;
  border-radius: 2px;
  transition: all 0.15s ease;
  pointer-events: none;
}

.text-block-highlight.hovered {
  background: rgba(0, 102, 204, 0.1);
  border-color: rgba(0, 102, 204, 0.5);
}

.text-block-highlight.selected {
  background: rgba(0, 102, 204, 0.2);
  border-color: #0066cc;
  box-shadow: 0 0 0 2px rgba(0, 102, 204, 0.2);
}

.text-block-highlight.hovered {
  outline: 1px dashed rgba(0,0,0,0.08);
}

.text-block-highlight.source-digital {
  border-color: rgba(50, 50, 50, 0.05);
}

.text-block-highlight.source-scanned {
  border-color: rgba(128, 0, 128, 0.45);
  background: rgba(128, 0, 128, 0.06);
}

.text-block-highlight.low-confidence {
  border-color: rgba(255, 140, 0, 0.8);
  background: rgba(255, 140, 0, 0.06);
}

.text-block-highlight.medium-confidence {
  border-color: rgba(255, 200, 0, 0.5);
}

.text-block-highlight.high-confidence {
  border-color: rgba(0, 150, 0, 0.5);
}

.text-tooltip {
  background: rgba(0, 0, 0, 0.78);
  color: #fff;
  padding: 6px 8px;
  border-radius: 4px;
  font-size: 12px;
  box-shadow: 0 6px 18px rgba(0,0,0,0.3);
  max-width: 320px;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}

.tooltip-content {
  display: inline-block;
  max-width: 320px;
  overflow: hidden;
  text-overflow: ellipsis;
  vertical-align: middle;
}

/* Canvas styles (applied by CanvasManager) */
:global(.pdf-canvas) {
  box-shadow: 0 2px 10px rgba(0, 0, 0, 0.3);
  background: white;
}

:global(.main-canvas) {
  z-index: 1;
}

:global(.overlay-canvas) {
  z-index: 2;
}
`, "",{"version":3,"sources":["webpack://./src/ui/components/PDFViewer.css"],"names":[],"mappings":"AAAA;EACE,OAAO;EACP,aAAa;EACb,sBAAsB;EACtB,gBAAgB;EAChB,mBAAmB;AACrB;;AAEA;EACE,kBAAkB;EAClB,OAAO;EACP,cAAc;EACd,aAAa;EACb,uBAAuB;EACvB,uBAAuB;EACvB,aAAa;AACf;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,kBAAkB;EAClB,MAAM;EACN,OAAO;EACP,oBAAoB;AACtB;;AAEA;EACE,kBAAkB;EAClB,cAAc;AAChB;;AAEA;EACE,kBAAkB;EAClB,6BAA6B;EAC7B,kBAAkB;EAClB,0BAA0B;EAC1B,oBAAoB;AACtB;;AAEA;EACE,kCAAkC;EAClC,oCAAoC;AACtC;;AAEA;EACE,kCAAkC;EAClC,qBAAqB;EACrB,4CAA4C;AAC9C;;AAEA;EACE,oCAAoC;AACtC;;AAEA;EACE,oCAAoC;AACtC;;AAEA;EACE,qCAAqC;EACrC,mCAAmC;AACrC;;AAEA;EACE,oCAAoC;EACpC,mCAAmC;AACrC;;AAEA;EACE,oCAAoC;AACtC;;AAEA;EACE,kCAAkC;AACpC;;AAEA;EACE,+BAA+B;EAC/B,WAAW;EACX,gBAAgB;EAChB,kBAAkB;EAClB,eAAe;EACf,sCAAsC;EACtC,gBAAgB;EAChB,mBAAmB;EACnB,gBAAgB;EAChB,uBAAuB;AACzB;;AAEA;EACE,qBAAqB;EACrB,gBAAgB;EAChB,gBAAgB;EAChB,uBAAuB;EACvB,sBAAsB;AACxB;;AAEA,6CAA6C;AAC7C;EACE,yCAAyC;EACzC,iBAAiB;AACnB;;AAEA;EACE,UAAU;AACZ;;AAEA;EACE,UAAU;AACZ","sourcesContent":[".pdf-viewer {\r\n  flex: 1;\r\n  display: flex;\r\n  flex-direction: column;\r\n  overflow: hidden;\r\n  background: #525659;\r\n}\r\n\r\n.pdf-canvas-container {\r\n  position: relative;\r\n  flex: 1;\r\n  overflow: auto;\r\n  display: flex;\r\n  justify-content: center;\r\n  align-items: flex-start;\r\n  padding: 20px;\r\n}\r\n\r\n.pdf-canvas-container.has-hover {\r\n  cursor: text;\r\n}\r\n\r\n.pdf-canvas-container.editing {\r\n  cursor: default;\r\n}\r\n\r\n.text-overlay {\r\n  position: absolute;\r\n  top: 0;\r\n  left: 0;\r\n  pointer-events: none;\r\n}\r\n\r\n.pdf-canvas-wrapper {\r\n  position: relative;\r\n  display: block;\r\n}\r\n\r\n.text-block-highlight {\r\n  position: absolute;\r\n  border: 2px solid transparent;\r\n  border-radius: 2px;\r\n  transition: all 0.15s ease;\r\n  pointer-events: none;\r\n}\r\n\r\n.text-block-highlight.hovered {\r\n  background: rgba(0, 102, 204, 0.1);\r\n  border-color: rgba(0, 102, 204, 0.5);\r\n}\r\n\r\n.text-block-highlight.selected {\r\n  background: rgba(0, 102, 204, 0.2);\r\n  border-color: #0066cc;\r\n  box-shadow: 0 0 0 2px rgba(0, 102, 204, 0.2);\r\n}\r\n\r\n.text-block-highlight.hovered {\r\n  outline: 1px dashed rgba(0,0,0,0.08);\r\n}\r\n\r\n.text-block-highlight.source-digital {\r\n  border-color: rgba(50, 50, 50, 0.05);\r\n}\r\n\r\n.text-block-highlight.source-scanned {\r\n  border-color: rgba(128, 0, 128, 0.45);\r\n  background: rgba(128, 0, 128, 0.06);\r\n}\r\n\r\n.text-block-highlight.low-confidence {\r\n  border-color: rgba(255, 140, 0, 0.8);\r\n  background: rgba(255, 140, 0, 0.06);\r\n}\r\n\r\n.text-block-highlight.medium-confidence {\r\n  border-color: rgba(255, 200, 0, 0.5);\r\n}\r\n\r\n.text-block-highlight.high-confidence {\r\n  border-color: rgba(0, 150, 0, 0.5);\r\n}\r\n\r\n.text-tooltip {\r\n  background: rgba(0, 0, 0, 0.78);\r\n  color: #fff;\r\n  padding: 6px 8px;\r\n  border-radius: 4px;\r\n  font-size: 12px;\r\n  box-shadow: 0 6px 18px rgba(0,0,0,0.3);\r\n  max-width: 320px;\r\n  white-space: nowrap;\r\n  overflow: hidden;\r\n  text-overflow: ellipsis;\r\n}\r\n\r\n.tooltip-content {\r\n  display: inline-block;\r\n  max-width: 320px;\r\n  overflow: hidden;\r\n  text-overflow: ellipsis;\r\n  vertical-align: middle;\r\n}\r\n\r\n/* Canvas styles (applied by CanvasManager) */\r\n:global(.pdf-canvas) {\r\n  box-shadow: 0 2px 10px rgba(0, 0, 0, 0.3);\r\n  background: white;\r\n}\r\n\r\n:global(.main-canvas) {\r\n  z-index: 1;\r\n}\r\n\r\n:global(.overlay-canvas) {\r\n  z-index: 2;\r\n}\r\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
